import type { FC } from "react";

import { SWReactIcons } from "@similarweb/icons";

import { StyledDDText, StyledDropdownButton, StyledIconWrapper } from "./styles";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
type RegionDropdownButtonProps = {
    name?: string;
};
const RegionDropdownButton: FC<RegionDropdownButtonProps> = ({ name }) => {
    return (
        <StyledDropdownButton>
            <StyledIconWrapper>
                <SWReactIcons
                    iconName="location-circled"
                    size="sm"
                />
            </StyledIconWrapper>
            <I18n
                translatable={{ key: `si.common.region.${name}.label` }}
                element={StyledDDText}
            />
        </StyledDropdownButton>
    );
};

export default RegionDropdownButton;
